import { FC, useCallback } from 'react';
import type { FileDownloadFormat } from '@/shared/lib';
import { useDownloadTemplates } from '../../model/api/hooks';
import type {
  DownloadTemplateEntityType,
  DownloadTemplateItem,
  DownloadTemplateSelection,
} from '../../model/api/types';
import { DownloadByTemplateMenu } from './DownloadByTemplateMenu';

type Props = {
  /** Сущность документа: её шаблоны и предлагаются в списке */
  entityType: DownloadTemplateEntityType;
  /** Скачивание по выбранному шаблону */
  onDownload: (selection: DownloadTemplateSelection) => void;
  /** Файл формируется — повторное скачивание не запускается */
  isPending: boolean;
  /** Классы кнопки-триггера */
  className?: string;
};

/**
 * Выбор шаблона при скачивании — общая точка для транскрипции, экспертного заключения и списка
 * диалогов. Пользователь выбирает и шаблон — состав документа, — и формат получаемого файла:
 * любой шаблон отдаётся в любом из трёх форматов. Перечень открыт всем, кому доступно само
 * скачивание, — разрешение на управление шаблонами не нужно.
 */
export const DownloadByTemplateButton: FC<Props> = ({ entityType, onDownload, isPending, className }) => {
  const { data } = useDownloadTemplates(entityType);

  const handleSelect = useCallback(
    (template: DownloadTemplateItem, format: FileDownloadFormat) => onDownload({ templateId: template.id, format }),
    [onDownload],
  );

  return (
    <DownloadByTemplateMenu
      templates={data?.templates ?? []}
      onSelect={handleSelect}
      isPending={isPending}
      className={className}
    />
  );
};
